import { render, staticRenderFns } from "./pubHeader.vue?vue&type=template&id=1ac84979&scoped=true&"
import script from "./pubHeader.vue?vue&type=script&lang=js&"
export * from "./pubHeader.vue?vue&type=script&lang=js&"
import style0 from "./pubHeader.vue?vue&type=style&index=0&id=1ac84979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac84979",
  null
  
)

export default component.exports